import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PIERHIPPAKComponent } from './module/pierhippak/pierhippak.component';
import { PIERHIPPLAComponent } from './module/pierhippla/pierhippla.component';
import { PIERHIPPNVComponent } from './module/pierhippnv/pierhippnv.component';
import { NotFoundComponent } from './not-found.component';
import { PIERHIPPALComponent } from './module/pierhippal/pierhippal.component';
import { PIERHIPPARComponent } from './module/pierhippar/pierhippar.component';
import { PIERHIPPNCComponent } from './module/pierhippnc/pierhippnc.component';
import { PIERHIBICOComponent } from './module/pierhibico/pierhibico.component';
import { PIERHIPPGAComponent } from './module/pierhippga/pierhippga.component';
import { PIERHIPPFLComponent } from './module/pierhippfl/pierhippfl.component';
import { PierchipragaModule } from './module/pierchipraga/pierchipraga.module';
import { PIERCHIPRAGAComponent } from './module/pierchipraga/pierchipraga.component';
import {PIERHIPPWVComponent }   from  './module/pierhippwv/pierhippwv.component';
import { PIERHIPPDEMOComponent } from './module/pierhippdemo/pierhippdemo.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'PIERHIPPGA',
    pathMatch: 'full',
  },
  {
    path: 'PIERHIPPLA',
    component: PIERHIPPLAComponent,
    title: 'LA HIPP Online Application - Apply Now',
  },
  {
    path: 'PIERHIPPAK',
    component: PIERHIPPAKComponent,
    title: 'AK HIPP Online Application - Apply Now',
  },
  {
    path: 'PIERHIPPNV',
    component: PIERHIPPNVComponent,
    title: 'NV HIPP Online Application - Apply Now',
  },
  {
    path: 'PIERHIPPAL',
    component: PIERHIPPALComponent,
    title: 'AL HIPP Online Application - Apply Now',
  },
  {
    path: 'PIERHIPPAR',
    component: PIERHIPPARComponent,
    title: 'AR HIPP Online Application - Apply Now',
  },
  {
    path: 'PIERHIPPFL',
    component: PIERHIPPFLComponent,
    title: 'FL HIPP Online Application - Apply Now',
  },
  {
    path: 'PIERHIPPGA',
    component: PIERHIPPGAComponent,
    title: 'GA HIPP Online Application - Apply Now',
  },
  {
    path: 'PIERHIPPNC',
    component: PIERHIPPNCComponent,
    title: 'NC HIPP Online Application - Apply Now',
  },
  {
    path: 'PIERHIBICO',
    component: PIERHIBICOComponent,
    title: 'CO HIBI Online Application - Apply Now',
  },
  {
    path: 'PIERCHIPRAGA',
    component: PIERCHIPRAGAComponent,
    title: 'GA CHIPRA Online Application - Apply Now',
  },
  {
    path: 'PIERHIPPWV',
    component: PIERHIPPWVComponent,
    title: 'WVHIPP Online Application - Apply Now',
  },
  {
    path: 'PIERHIPPDEMO',
    component: PIERHIPPDEMOComponent,
    title: 'DEMOHIPP Online Application - Apply Now',
  },
  {
    path: '**',
    component: NotFoundComponent,
    title: 'Page Not Found',
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
